import React from "react"
import FooterSectional from "../FooterSectional/FooterSectional"
import Layout from "../layout"
import BottomFiller from "../Sectional/BottomFiller/BottomFiller"
import * as styles from './GalleryCollection.module.css';
import config from "../../config";
import { Helmet } from "react-helmet";

class Home extends React.Component {
  render() {
    const {
      client='season1',
      themeColor,
    } = this.props;
    return (
      <div className={styles.container}>
      <Layout client={client}>
        <Helmet>
          <title>{config[client].galleryName}</title>
          <link rel="shortcut icon" href={`/${config[client].faviconName}`} type="image/x-icon" />
        </Helmet>
        <div className={styles.loading}>
          <h4>Loading...</h4>
        </div>
        <table border="0" cellspacing="0" cellpadding="0" id="hold-iframe">
          <div>
            <iframe id="iframe" src={config[client].collectionEmbedIframe}
              width='100%'
              height='1600px'
              frameBorder='0'
              allowFullScreen></iframe>
          </div>
        </table>
        <FooterSectional themeColor={themeColor} client={client} />
        <BottomFiller client={client} />
      </Layout>
      </div>
    );
  }
}

export default Home
